import React from "react";
import { useParams, Link } from "react-router-dom";
import projects from "assets/projects_info";
import ProjectHeaderComponent from "./ProjectHeaderComponent"
import ProjectTableComponent from "./ProjectTableComponent"
import ProjectGridComponent from "./ProjectGridComponent"

const ProjectDetailPage = () => {

  const { id } = useParams();
  const project = projects.find((p) => p.id === id);

  if (!project) {
    return <div>Project not found</div>;
  }

  return (
    <div className="project-detail">
      <ProjectHeaderComponent
        backgroundImage={project.thumbnail} 
        type={project.type}
        title={project.title} 
      />

    <div>
      <ProjectTableComponent
        title = {project.title}
        status = {project.status}
        scopeWord = {project.scopeWord}
        />
    </div>
      
      <div className="project-images">
        <ProjectGridComponent imagesInfo={project.imagesInfo}/>
      </div>
            
    </div>
  );
}

export default ProjectDetailPage;